import { useFormikContext } from 'formik'

import { EMPTY_STRING } from '../../../../../../../constants/common'

export function useParameterRowHandlers({
  actionName,
  commentName,
  commentTemplateName,
  index,
  isCommentName,
  isDeleteDisabled,
  selectedActionValue,
  selectedFieldValue,
  valueName,
  onRemoveParameter,
}) {
  const { setFieldValue } = useFormikContext()

  function handleResetNotification() {
    setFieldValue(commentName, EMPTY_STRING)
    setFieldValue(isCommentName, false)
    setFieldValue(commentTemplateName, EMPTY_STRING)
  }

  function handleResetActionAndValue() {
    setFieldValue(actionName, null)
    setFieldValue(valueName, null)
    handleResetNotification()
  }

  function handleResetValue() {
    setFieldValue(valueName, null)
    handleResetNotification()
  }

  function handleFieldChange(nextField) {
    if (nextField?.value !== selectedFieldValue) {
      handleResetActionAndValue()
    }
  }

  function handleActionChange(nextAction) {
    if (nextAction?.value !== selectedActionValue) {
      handleResetValue()
    }
  }

  function handleRemove() {
    if (!isDeleteDisabled) {
      onRemoveParameter(index)
    }
  }

  return {
    handleActionChange,
    handleFieldChange,
    handleRemove,
    handleResetActionAndValue,
    handleResetValue,
  }
}
